// League picker, split Women's | Men's. `off` = tag only (shown greyed, not openable yet).
export const LEAGUE_GROUPS = [
    ["W", "Women's Hockey", [
        { id: "pwhl", name: "PWHL", to: "/overview", color: "#9D4CDD" },
        { id: "ncaa", name: "NCAA", to: "/ncaa/schedule", color: "#2563EB" },
        { id: "international", name: "WWHC", to: "/nat/schedule", color: "#E11D48", full: "Women's World Championship" },
        { id: "olympics", name: "Olympics", color: "#F6C453", off: true },
    ]],
    ["M", "Men's Hockey", [
        { id: "nhl", name: "NHL", to: "/nhl/schedule", color: "#8A94A6" },
        { id: "wjc", name: "WJC", color: "#38BDF8", off: true, full: "World Junior Championship" },
    ]],
];
export const LEAGUE_OPTS = LEAGUE_GROUPS.flatMap(([, , l]) => l).filter((l) => !l.off);
